import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import EditTextForm from '../../common/components/EditTextForm/EditTextForm';
import MarginInput from '../../common/components/MarginInput/MarginInput';
import ModalContainer from '../../common/components/ModalContainer/ModalContainer';
import Paint from '../../common/components/Paint/Paint';
import SelectBox from '../../common/components/SelectBox/SelectBox';
import { COLORS } from '../../common/constants/colors';
import { getError, openNotification, tryCatch } from '../../common/constants/Utilities';
import GroupRow from '../../common/components/GroupRow/GroupRow';
import { IDepartment } from '../../interfaces/IDepartment';
import { IQuestionGroup } from '../../interfaces/IQuestion';
import { InsertAQuestionsGroup, UpdateQuestionsGroup } from '../../services/questionGroup';
import './GrupoPreguntas.css';
import globalStyle from '../../common/styles/globalStyle.module.css';
import LoadingButton from '../../common/components/LoadingButton/LoadingButton';
import ModalBtnCotainer from '../../common/components/ModalBtnContainer/ModalBtnContainer';
import { Mode } from '../../common/types/AllTypes';
import GroupColumn from '../../common/components/GroupColumn/GroupColumn';

interface Props {
    questionGroupUpdate?: IQuestionGroup;
    mode: Mode;
    setQuestionGroupUpdate: any;
    setAddUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
    listDepartment: IDepartment[];
    loadingDeparment: boolean;
    setDataList: (list: IQuestionGroup[]) => void;
    dataList: IQuestionGroup[];
    defaultDepartmentGUID?: string;
}

const AddUpdateQuestionGroup = ({ dataList, setDataList, questionGroupUpdate, mode, setQuestionGroupUpdate, setAddUpdateModal, listDepartment, loadingDeparment, defaultDepartmentGUID }: Props) => {

    // States
    const [formLoading, setFormLoading] = useState<boolean>(false);

    // Methods
    const validations = (values: any) => {
        const errors: any = {};
        if (!values.nombre) {
            errors.nombre = 'Requerido';
        }

        if (!values.departamentoGUID) {
            errors.departamentoGUID = 'Requerido';
        }

        if (!!values.atributoNombre1 && !values.atributoValor1) {
            errors.atributoValor1 = 'Requerido';
        }
        if (!values.atributoNombre1 && !!values.atributoValor1) {
            errors.atributoNombre1 = 'Requerido';
        }

        if (!!values.atributoNombre2 && !values.atributoValor2) {
            errors.atributoValor2 = 'Requerido';
        }
        if (!values.atributoNombre2 && !!values.atributoValor2) {
            errors.atributoNombre2 = 'Requerido';
        }

        if (!!values.atributoNombre3 && !values.atributoValor3) {
            errors.atributoValor3 = 'Requerido';
        }
        if (!values.atributoNombre3 && !!values.atributoValor3) {
            errors.atributoNombre3 = 'Requerido';
        }

        return errors;
    };

    // Handles
    const handleQuestionGroup = (values: any) => {
        setFormLoading(true);
        const newQuestionGroup: IQuestionGroup = {
            grupoPreguntaID: 0,
            nombre: values.nombre,
            departamentoGUID: values.departamentoGUID,
            atributoNombre1: !!values.atributoNombre1 ? values.atributoNombre1 : null,
            atributoValor1: !!values.atributoValor1 ? values.atributoValor1 : null,
            atributoNombre2: !!values.atributoNombre2 ? values.atributoNombre2 : null,
            atributoValor2: !!values.atributoValor2 ? values.atributoValor2 : null,
            atributoNombre3: !!values.atributoNombre3 ? values.atributoNombre3 : null,
            atributoValor3: !!values.atributoValor3 ? values.atributoValor3 : null,
        }

        tryCatch(() => {
            if (mode === 'Add') {
                InsertAQuestionsGroup(newQuestionGroup)
                    .then((response) => {
                        openNotification('success', `Grupo de Preguntas agregado`, response.msg!);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IQuestionGroup = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;
                        dataList.push(result);
                        setDataList([...dataList]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            } else {
                newQuestionGroup.grupoPreguntaID = questionGroupUpdate!.grupoPreguntaID;
                UpdateQuestionsGroup(newQuestionGroup)
                    .then((response) => {
                        openNotification('success', `Grupo de Preguntas Modificado`, response.msg!);
                        setQuestionGroupUpdate(response.data);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IQuestionGroup = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;
                        let attr = dataList.findIndex(x => x.grupoPreguntaID === questionGroupUpdate?.grupoPreguntaID);
                        dataList[attr] = result;
                        setDataList([...dataList]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            }
        })
    }

    // Form
    const QuestionGroupForm = useFormik({
        initialValues: { nombre: '', departamentoGUID: '', atributoNombre1: '', atributoValor1: '', atributoNombre2: '', atributoValor2: '', atributoNombre3: '', atributoValor3: '', },
        validate: validations,
        onSubmit: (values: any) => handleQuestionGroup(values)
    });


    // Effects
    useEffect(() => {
        if (mode === 'Update') {
            QuestionGroupForm.setValues({
                nombre: questionGroupUpdate!.nombre,
                departamentoGUID: questionGroupUpdate!.departamentoGUID,
                atributoNombre1: questionGroupUpdate!.atributoNombre1 || '',
                atributoValor1: questionGroupUpdate!.atributoValor1 || '',
                atributoNombre2: questionGroupUpdate!.atributoNombre2 || '',
                atributoValor2: questionGroupUpdate!.atributoValor2 || '',
                atributoNombre3: questionGroupUpdate!.atributoNombre3 || '',
                atributoValor3: questionGroupUpdate!.atributoValor3 || ''
            });
        }

    }, [questionGroupUpdate]);

    useEffect(() => {
        if (!!defaultDepartmentGUID) {
            QuestionGroupForm.setFieldValue('departamentoGUID', defaultDepartmentGUID);
        }
    }, [])


    return (
        <ModalContainer>
            <GroupRow>
                <MarginInput width="100%">
                    <label>Nombre:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.nombre}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"nombre"}
                        placeholder={"Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{QuestionGroupForm.errors.nombre && QuestionGroupForm.errors.nombre}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="100%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={QuestionGroupForm.values.departamentoGUID}
                        defaultValue={mode === 'Update' ? questionGroupUpdate!.departamentoGUID : null}
                        placeholder={"Departamento"}
                        disabled={mode === 'Update' || !!defaultDepartmentGUID ? true : false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => QuestionGroupForm.setFieldValue('departamentoGUID', value)}
                        options={listDepartment.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoGUID, text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{QuestionGroupForm.errors.departamentoGUID && QuestionGroupForm.errors.departamentoGUID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>



            <GroupRow style={{ marginTop: '10px', borderTop: `1px solid ${COLORS.black_text_color3}`, paddingTop: 40 }}>
                <GroupColumn width="45%">
                    <label>Atributo 1:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.atributoNombre1}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color1}
                        name={"atributoNombre1"}
                        placeholder={"Atributo 1"}
                        borderColor={QuestionGroupForm.errors.atributoNombre1 ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                </GroupColumn>
                <GroupColumn width="45%">
                    <label>Valor 1:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.atributoValor1}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color1}
                        name={"atributoValor1"}
                        placeholder={"Valor 1"}
                        borderColor={QuestionGroupForm.errors.atributoValor1 ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                </GroupColumn>
            </GroupRow>

            <GroupRow style={{ marginTop: '30px' }}>
                <GroupColumn width="45%">
                    <label>Atributo 2:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.atributoNombre2}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color1}
                        name={"atributoNombre2"}
                        placeholder={"Atributo 2"}
                        borderColor={QuestionGroupForm.errors.atributoNombre2 ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                </GroupColumn>
                <GroupColumn width="45%">
                    <label>Valor 2:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.atributoValor2}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color1}
                        name={"atributoValor2"}
                        placeholder={"Valor 2"}
                        borderColor={QuestionGroupForm.errors.atributoValor2 ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                </GroupColumn>
            </GroupRow>
            <GroupRow style={{ marginTop: '30px', paddingBottom: '4.5em' }}>
                <GroupColumn width="45%">
                    <label>Atributo 3:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.atributoNombre3}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color1}
                        name={"atributoNombre3"}
                        placeholder={"Atributo 3"}
                        borderColor={QuestionGroupForm.errors.atributoNombre3 ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                </GroupColumn>
                <GroupColumn width="45%">
                    <label>Valor 3:</label>
                    <EditTextForm
                        value={QuestionGroupForm.values.atributoValor3}
                        onChange={QuestionGroupForm.handleChange}
                        backgroundcolor={COLORS.white_color1}
                        name={"atributoValor3"}
                        placeholder={"Valor 3"}
                        borderColor={QuestionGroupForm.errors.atributoValor3 ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                </GroupColumn>
            </GroupRow>

            <ModalBtnCotainer>
                <LoadingButton
                    type="button"
                    method={QuestionGroupForm.handleSubmit}
                    title={mode === 'Add' ? "Guardar" : 'Modificar'}
                    loading={formLoading.toString()}
                    background={COLORS.blue_active}
                    color={COLORS.white_color1}
                    style={{ padding: '3px', width: '200px', margin: 'auto', height: '32px' }}
                    fontsize={16}
                />
            </ModalBtnCotainer>
        </ModalContainer>
    )
}

export default AddUpdateQuestionGroup;